import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sky-footer',
  templateUrl: './sky-footer.component.html',
  styleUrls: ['./sky-footer.component.scss']
})
export class SkyFooterComponent implements OnInit {
  @Input() scope;
  constructor() {}
  ngOnInit(): void {}
}
